$(document).ready(function () {
  // =======================
  // 1. Product Highlight Slider
  // =======================
  $('.product-highlight-main').slick({
    dots: false,
    arrows: true,
    prevArrow: $('.custom-prev-2'),
    nextArrow: $('.custom-next-2'),
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
  });

  // =======================
  // 2. Toggle Button for Content Show/Hide
  // =======================
  $(".toggle-btn").on("click", function () {
    let wrapper = $(this).closest(".toggle-wrapper");
    let content = wrapper.find(".toggle-content");

    if (wrapper.hasClass("active")) {
      wrapper.removeClass("active");
      content.stop(true, true).slideUp(300); 
    } else {
      wrapper.addClass("active");
      content.stop(true, true).slideDown(300); 
    }
  });

  // =======================
  // 3. Testimonial Slider (Responsive)
  // =======================
  var $slider = $('.testimonial-main-slider');
  var sliderEnabled = $slider.data('enable-slider');
  var columnsDesktop = $slider.data('columns-desktop');

  function initMobileSlider() {
    if ($(window).width() <= 768) {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: false,
          infinite: true,
          speed: 700,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: $('.custom-prev'),
          nextArrow: $('.custom-next'),
        });
      }

      $('.testimonial-slider-buttons').show();
      if (sliderEnabled) {
        $('.tesitonmial-button').show();
      } else {
        $('.tesitonmial-button').hide();
      }

    } else {
      if (sliderEnabled) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            dots: false,
            infinite: true,
            speed: 800,
            slidesToShow: columnsDesktop,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $('.custom-prev'),
            nextArrow: $('.custom-next'),
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
          $('.testimonial-slider-buttons').show();
          $('.tesitonmial-button').show();
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
        $('.testimonial-slider-buttons').hide();
      }
    }
  }

  initMobileSlider();

  $(window).on('resize', function () {
    initMobileSlider();
  });

  // =======================
  // 4. Center Mode Slider
  // =======================
  $('.center-slider').slick({
    infinite: true,
    slidesToShow: 1, 
    slidesToScroll: 1,
    speed: 1000,
    autoplaySpeed: 3000,
    autoplay: true,
    centerMode: true,
    centerPadding: "200px",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

  // =======================
  // 5. Before-After Slider
  // =======================
  $('.before-after-main').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.custom-prev-3'),
    nextArrow: $('.custom-next-3'),
    dots: true,
    appendDots: $('.before-after-slider-dots'),
    speed: 900,
    infinite: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  // Optional: ensure it's visible after init
  $('.before-after-main').css('visibility', 'visible');
});
